import React from "react";
import { Col, Row, Button, Form } from "react-bootstrap";
import { getStripeSettingAction } from "./../../actions/UserActions";
import {
  updatePlanSettingsAction,
  getPlanProviderAction,
  updatePlanProviderAction,
} from "./../../actions/PlanSettingActions";
import * as code from "./../../config/Constants";
import { connect } from "react-redux";

class PlanSetting extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: true,
      isSubscriptionEnabled: true,
      id: "",
      planProvider: [],
      selectedProvider: "",
      providerName: "",
    };
  }

  componentDidMount() {
    // this.stripeSettingAction();
    this.planProviderAction();
  }

  /** get stripe setting */
  // stripeSettingAction() {
  //     this.props.getStripeSettingAction().then(res => {
  //         this.setState({ showLoader: false })
  //         if (res.status == code.OK) {
  //             this.setState({ id: res.data[0]._id, isSubscriptionEnabled: res.data[0].isSubscriptionEnabled });
  //         }
  //     })
  // }
  /** get stripe setting */
  planProviderAction() {
    this.props.getPlanProviderAction().then((res) => {
      this.setState({ showLoader: false });
      if (res.status == code.OK) {
        this.setState({ planProvider: res.data });
        res.data.map((plan) => {
          if (plan.isSelected) {
            this.setState({
              selectedProvider: plan._id,
              providerName: plan.name,
            });
          }
        });
      }
    });
  }
  /** update stripe flag */
  updateStripeSetting() {
    this.setState({ showLoader: true });
    var data = {
      id: this.state.id,
      flag: this.state.isSubscriptionEnabled,
      providerName: this.state.providerName,
    };
    this.props.updatePlanSettingsAction(data).then((res) => {
      this.setState({ showLoader: false });
      if (res.status === code.OK) {
        if (this.state.isSubscriptionEnabled) {
          localStorage.setItem(code.IS_STRIPE_ENABLED, "true");
        } else {
          localStorage.setItem(code.IS_STRIPE_ENABLED, "false");
        }
        window.location.reload(false);
      }
    });
  }
  /** update plan provider */
  updatePlanProvider() {
    var data = {
      id: this.state.selectedProvider,
      flag: true,
      providerName: this.state.providerName,
    };
    this.props.updatePlanProviderAction(data);
  }
  render() {
    if (this.state.showLoader) {
      return (
        <div className="page-loader fixed">
          <div className="page-loader-inner">
            <div className="spinner-border" role="status">
              <span className="sr-only">Loading...</span>
            </div>
          </div>
        </div>
      );
    } else {
      return (
        <>
          <Row className="ml-0 mr-0 page-head-row page-head-row-big align-items-center">
            <Col className="col-auto">
              <h4 className="title-med mt-0 pt-1">Plan Configuration</h4>
            </Col>
          </Row>
          <div className="admin-content-area single">
            <Form>
              <div className="notification-setting">
                <Row className="form-group align-items-center">
                  <Col className="col-auto">
                    <h4>Paid Subscription</h4>
                  </Col>

                  <Col className="pl-0">
                    <div className="custom-control custom-control-inline custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        name={"radioObject.enable"}
                        key={"radioObject"}
                        checked={this.state.isSubscriptionEnabled == true}
                        id={"displayMessageEnable"}
                        onChange={(e) => {
                          this.setState({
                            isSubscriptionEnabled: !this.state
                              .isSubscriptionEnabled,
                          });
                        }}
                        value={true}
                      />
                      <label
                        title=""
                        for={"displayMessageEnable"}
                        className="custom-control-label"
                      >
                        Enable
                      </label>
                    </div>
                    <div className="custom-control custom-control-inline custom-radio">
                      <input
                        type="radio"
                        className="custom-control-input"
                        value={false}
                        id={"displayMessageDisable"}
                        key={"radioObjectdisable"}
                        name={"radioObject.enable"}
                        checked={this.state.isSubscriptionEnabled == false}
                        onChange={(e) => {
                          this.setState({
                            isSubscriptionEnabled: !this.state
                              .isSubscriptionEnabled,
                          });
                        }}
                      />

                      <label
                        title=""
                        for={"displayMessageDisable"}
                        className="custom-control-label"
                      >
                        Disable
                      </label>
                    </div>
                  </Col>
                </Row>
                {this.state.isSubscriptionEnabled ? (
                  <Row className="form-group align-items-center">
                    <Col className="col-auto">
                      <h4>Subscription Provider</h4>
                    </Col>
                    <Col xs={12} sm={4}>
                      <div
                        className="c-select"
                        style={{ border: "1px solid " }}
                      >
                        <select
                          name="provider"
                          className="form-control form-control-sm"
                          value={this.state.selectedProvider}
                          onChange={(e) =>
                            this.setState({
                              selectedProvider: e.target.value,
                              providerName:
                                e.target.options[e.target.selectedIndex].text,
                            })
                          }
                        >
                          {this.state.planProvider &&
                            this.state.planProvider.map((plan) => {
                              return (
                                <option value={plan._id}>{plan.name}</option>
                              );
                            })}
                        </select>
                      </div>
                    </Col>
                  </Row>
                ) : (
                  ""
                )}
                <Row className="form-group pt-4">
                  <Col>
                    <Button
                      type="submit"
                      variant="primary"
                      className="btn-blue w-90 font-14 mr-3"
                      onClick={() => {
                        this.updateStripeSetting();
                        if (this.state.isSubscriptionEnabled) {
                          this.updatePlanProvider();
                        }
                      }}
                    >
                      Save
                    </Button>
                    <Button
                      variant="primary"
                      className="btn-blue btn-outlined w-90 font-14"
                      onClick={() => this.props.history.goBack()}
                    >
                      Cancel
                    </Button>
                  </Col>
                </Row>
              </div>
            </Form>
          </div>
        </>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {};
};
export default connect(
  mapStateToProps,
  {
    getStripeSettingAction,
    updatePlanSettingsAction,
    getPlanProviderAction,
    updatePlanProviderAction,
  }
)(PlanSetting);
